import { render, staticRenderFns } from "./OfficePhaseList.vue?vue&type=template&id=6a29803a&"
import script from "./OfficePhaseList.vue?vue&type=script&lang=js&"
export * from "./OfficePhaseList.vue?vue&type=script&lang=js&"
import style0 from "./OfficePhaseList.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports